/**
 * 本地 mock 配置(客户端 / SSR 共用)。
 *
 * LOCAL_MOCK_PATHS 里列出的接口,在 NEXT_PUBLIC_MOCK_LOCAL 开启时(见 .env.development.local),
 * 会被 src/utils/axios.ts 的请求拦截器单独把 baseURL 改写到本地 dev server(localhost:4000),
 * 从而走 server/middlewares/mock 中间件返回 mock 数据;**其余接口仍直连远程 API_HOST,不受影响**。
 *
 * 注意:这里只决定「哪些接口重定向到本地」。本地命中后返回什么数据,由 server 端的
 * server/config/mock.config.js + server/mocks/** 决定,两边需要对应:
 *   - 这里加 '/ec/xxx'  →  server/config/mock.config.js 的 urls 也要有 '/ec/xxx' 的映射。
 *
 * 用 path 前缀匹配(startsWith)。
 */
export const LOCAL_MOCK_PATHS: string[] = ['/ec/search/keyword'];
